import { ErrorLayout } from 'components';
import { useTranslation } from 'libs/i18n';
import { ROUTES, useNavigate } from 'libs/navigation';

export const NotFound = () => {
  const { t } = useTranslation();
  const { navigate } = useNavigate();

  const handleClick = () => {
    navigate(ROUTES.fullPath, {}, { replace: true });
  };

  return (
    <ErrorLayout
      buttonLabel={t('notFound.buttonLabel')}
      subtitle={t('notFound.subtitle')}
      onButtonClick={handleClick}
    />
  );
};
